<template>
    <div class="tooltip">
        <v-row>
            <v-col :cols="3" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0">
                Affinity/Association
            </v-col>
            <v-col :cols="8" class="text-left no-left no-bottom no-top pa-0 ma-0">
                <v-row>
                    <v-col :cols="10" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0">
                        <v-text-field v-model="affinity" ref="company"/>
                    </v-col>
                    <v-col :cols="2" class="text-left no-left no-bottom no-top pa-0 ma-0">
                        <v-progress-circular
                            :width="3"
                            :size="20"
                            color="primary"
                            indeterminate
                            v-if="showSpinner"
                            ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="2" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0"></v-col>
            <v-col :cols="8" class="text-left no-left no-bottom no-top pa-0 ma-0">
                <div id=companytooltip__tooltip>
                    <ul id="companytooltip__tooltip--list">
                        <li 
                        v-for="(a, i) in affinityList" 
                        v-bind:key="i" 
                        v-ripple="{ class: `primary--text` }"
                        @click.prevent="choose(a)"
                        v-html="fmtStr(a)"
                        />
                    </ul>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="2" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0"></v-col>
            <v-col :cols="8" class="text-left no-left no-bottom  pa-0 ma-0">
                <v-btn small color="primary" @click="close()">Close</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'AffinityAssociationTooltip',
    data: () => ({
        affinityList: [],
        affinity: '',
        working: false,
        showSpinner:false
    }),
    methods: {
        close: function() {
            this.$emit('closeAffinityAssociation', false)
        },
        choose: function(o) {
            var view = this
             if (view.isSelected(o)) {
                alert("You are selecting already selected affinity.")
            }else{
                this.$emit('chooseAffinity', o)
            }
        },
        isSelected: function(o) {
            var view = this,
                aff = view.$store.getters['ProductData/getAffinity']
                //console.log(aff);
            return aff.find(e => (e.affinityID === o.affinityID))
        },
        fmtStr: function(a) {
            let affinity_name = a.affinityName + (a.AffinityCategoryName === null ? '' : ' (' + a.AffinityCategoryName + ') ')
            if(this.isSelected(a)){
              return '*' +  affinity_name
            }
            return affinity_name
        }
    },
    watch: {
        affinity: function(o) {
            var view = this
            this.showSpinner = true
            if (o.length >= 2 && view.working === false) {
                console.log('asdas');
                view.working = true
                
                view.$fetch({
                    url: view.$url('API') + '/data/affinity',
                    type: 'POST',
                    data: JSON.stringify({
                        affinity: o,
                    }),
                    contentType: "application/json",
                },{
                operation: 'add',
                vueScope: view
            }).then(function(response) {
                    view.showSpinner = false
                    if (response.length > 0) {
                        view.affinityList = []
                        response.forEach(function(o) {
                            view.affinityList.push(o)
                        })
                    }
                    view.working = false
                }).catch(e => console.log(e),view.showSpinner = false)
            }else{
                view.affinityList = []
                view.showSpinner = false
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/addcompanytooltip'
.v-progress-circular
    top:12%
</style>